'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Icon, Row, Typography } from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'

export const DepositWithNumberCTA = ({
  origin,
}: {
  origin: 'layout' | 'container'
}) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()
  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0' : ''} bg-neutral-surface-light p-xs md:p-0 gap-xs justify-between`}
    >
      <Row className='w-full justify-between'>
        {origin === 'layout' && (
          <ButtonLink
            variant='transparent'
            size='md'
            color='neutral'
            href='/wallet/deposit'
            aria-label='Back to Deposit'
            startIcon={<Icon name='ArrowRightLine' size='md' />}
          >
            {!isDesktop && (
              <Typography size='md' weight='bold'>
                {t('walletDepositWithNumberPage_title')}
              </Typography>
            )}
          </ButtonLink>
        )}
        {isDesktop && (
          <Typography size='md' weight='bold'>
            {t('walletDepositWithNumberPage_title')}
          </Typography>
        )}
        {!isDesktop && (
          <ButtonLink
            variant='transparent'
            size='xs'
            color='base'
            href='/history/balance'
            aria-label='History'
            startIcon={<Icon name='ClockHistoryCircleGhostLine' size='xs' />}
          />
        )}
      </Row>
    </Row>
  )
}
